var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { WindowService } from './../../services/window.service';
import { ApiService } from './../../services/api.service';
import { BountyService } from '../../services/bounty.service';
import { OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { SuiModalService } from 'ng2-semantic-ui';
import { ConfirmModal } from '../confirm-modal/confirm-modal.component';
var UserProfileComponent = /** @class */ (function () {
    function UserProfileComponent(bountyService, userService, route, apiService, windowService, modalService) {
        this.bountyService = bountyService;
        this.userService = userService;
        this.route = route;
        this.apiService = apiService;
        this.windowService = windowService;
        this.modalService = modalService;
        this.fetching = true;
        this.refunding = false;
        this.loggedInUser = this.userService.getUser();
        this.userId = this.route.snapshot.paramMap.get('id');
    }
    UserProfileComponent.prototype.ngOnInit = function () {
        // Get initial pre-rendered data from window object
        var preRenderedData = this.windowService.appData;
        if (preRenderedData) {
            var bountiesCreated = preRenderedData.bountiesCreated, bountiesLiked = preRenderedData.bountiesLiked, bountiesClaimed = preRenderedData.bountiesClaimed, user = preRenderedData.user, payments = preRenderedData.payments;
            this.bountiesCreated = bountiesCreated;
            this.bountiesLiked = bountiesLiked;
            this.bountiesClaimed = bountiesClaimed;
            this.userProfile = user;
            this.fetching = false;
            this.payments = payments;
        }
        else {
            this.fetchData();
        }
    };
    UserProfileComponent.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, bountiesCreated, bountiesLiked, bountiesClaimed, user, payments;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.fetching = true;
                        return [4 /*yield*/, this.bountyService.getUserProfile(this.userId)];
                    case 1:
                        _a = _b.sent(), bountiesCreated = _a.bountiesCreated, bountiesLiked = _a.bountiesLiked, bountiesClaimed = _a.bountiesClaimed, user = _a.user, payments = _a.payments;
                        this.bountiesCreated = bountiesCreated;
                        this.bountiesLiked = bountiesLiked;
                        this.bountiesClaimed = bountiesClaimed;
                        this.userProfile = user;
                        this.fetching = false;
                        this.payments = payments;
                        return [2 /*return*/];
                }
            });
        });
    };
    UserProfileComponent.prototype.banUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService
                            .post('ban-user', { userId: this.userProfile.id })
                            .toPromise()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchData()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserProfileComponent.prototype.unbanUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService
                            .post('unban-user', { userId: this.userProfile.id })
                            .toPromise()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchData()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(UserProfileComponent.prototype, "isMe", {
        get: function () {
            return (this.loggedInUser &&
                this.userProfile &&
                this.userProfile.id === this.loggedInUser.id);
        },
        enumerable: true,
        configurable: true
    });
    UserProfileComponent.prototype.refundPayment = function (payment) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.modalService
                    .open(new ConfirmModal('Refund payment', "Are you sure you want to refund this payment?"))
                    .onApprove(function () { return __awaiter(_this, void 0, void 0, function () {
                    var e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.refunding = true;
                                this.refundError = undefined;
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 4, , 5]);
                                return [4 /*yield*/, this.apiService.post("refund-payment/" + payment.id, {}).toPromise()];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, this.fetchData()];
                            case 3:
                                _a.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                e_1 = _a.sent();
                                if (e_1.error && e_1.error.error) {
                                    this.refundError = e_1.error.error;
                                }
                                else {
                                    this.refundError = 'A server error occured.';
                                }
                                return [3 /*break*/, 5];
                            case 5:
                                this.refunding = false;
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    UserProfileComponent.prototype.paymentStatusLabelClass = function (payment) {
        switch (payment.payment_status) {
            case 'refunded': return 'orange';
            case 'approved': return 'green';
            default: return '';
        }
    };
    return UserProfileComponent;
}());
export { UserProfileComponent };
